import moment from "moment";

class CommonHelper {

    static getFileName = (file, defaultName = 'file') => {
        return (file?.name) ? file.name.substr(0, file.name.lastIndexOf('.')) : defaultName;
    }

    static getFileExtension = (file) => {
        return file.name.substr(file.name.lastIndexOf('.') + 1);
    }

    static getFileNameWithTimestamp = (file) => {
        const name = this.getFileName(file);
        const extension = this.getFileExtension(file);

        return `${name}_${moment().format('YYYYMMDDhhmmssSSS')}.${extension}`;
    }

    static mapProjectReportStatusOrder = (data) => {
        const sortingPriority = [
            'Waiting for supporting data',
            'Prelim advise compose by Surveyor',
            'Prelim advise compose by Admin',
            'Prelim advise being review by Admin',
            'Prelim advise being review by Pak Alif',
            'Prelim advise being review by Pak Fauzi',
            'Prelim advise being review by Pak Faishal',
            'Prelim Advice Issued',
            'Draft Report compose by Surveyor',
            'Draft Report compose by Admin',
            'Draft Report being review by Admin',
            'Draft Report Final being review by Pak Alif',
            'Draft Report Final being review by Pak Fauzi',
            'Draft Report Final being review by Pak Faishal',
            'Report ready to be issue',
            'Report issued',
          ];

        const sorted = data.sort((a, b) => {
            const nameA = a.name.trim();
            const nameB = b.name.trim();
            const indexA = sortingPriority.indexOf(nameA);
            const indexB = sortingPriority.indexOf(nameB);
        
            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
            if (indexA !== -1) return -1;
            if (indexB !== -1) return 1;
        
            return nameA.localeCompare(nameB);
        });

        return sorted;
    }

    static mapProjectApprovalStatusOrder = (data) => {
        const sortingPriority = [
            'Waiting For Supporting Data',
            'Draft Approval being compose by Admin',
            'Draft Approval being review by Admin',
            'Draft Approval being review by Surveyor',
            'Draft Approval being review by Pak Alif',
            'Draft Approval being review by Pak Fauzi',
            'Final Draft sent to Clients',
            'Approval ready to be issued',
            'Approval issued',
          ];
          
        const sorted = data.sort((a, b) => {
            const nameA = a.name.trim();
            const nameB = b.name.trim();
            const indexA = sortingPriority.indexOf(nameA);
            const indexB = sortingPriority.indexOf(nameB);
        
            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
            if (indexA !== -1) return -1;
            if (indexB !== -1) return 1;
        
            return nameA.localeCompare(nameB);
        });

        return sorted;
    }

    static checkPermission = (permission_list = [], name) => {
        let all = permission_list.filter((item) => item === name);
        if (all.length > 0) return true;
        return false;
    };

    static initialNameGenerator(name) {
        if (!name || typeof name !== 'string') return '?';
        const parts = name.trim().split(/\s+/).filter(Boolean);
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return name.slice(0, 2).toUpperCase();
    }

    static numOrDash(v) {
        if (v === null || v === undefined || v === '') return '—';
        const n = Number(v);
        return Number.isFinite(n) ? n : '—';
    }

    static splitIdList(val) {
        if (val === null || val === undefined || val === '') return [];
        if (Array.isArray(val)) return val.map(String).map((s) => s.trim()).filter(Boolean);
        return String(val)
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);
    }

    static hexToRgb(hex) {
        if (!hex || typeof hex !== 'string') return null;
        let h = hex.trim().replace(/^#/, '');
        if (h.length === 3) {
            h = h
                .split('')
                .map((c) => c + c)
                .join('');
        }
        if (h.length !== 6 || !/^[a-fA-F0-9]+$/.test(h)) return null;
        const n = parseInt(h, 16);
        return {
            r: (n >> 16) & 255,
            g: (n >> 8) & 255,
            b: n & 255,
        };
    }

    static darkenHex(hex, factor) {
        const rgb = this.hexToRgb(hex);
        if (!rgb) return '#dddddd';
        const clamp = (n) => Math.max(0, Math.min(255, Math.round(n)));
        const r = clamp(rgb.r * factor);
        const g = clamp(rgb.g * factor);
        const b = clamp(rgb.b * factor);
        return `#${[r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('')}`;
    }


}

export default CommonHelper;